import { render, staticRenderFns } from "./InvestorPageData.vue?vue&type=template&id=25aef8cb&scoped=true&"
import script from "./InvestorPageData.vue?vue&type=script&lang=js&"
export * from "./InvestorPageData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPageData.vue?vue&type=style&index=0&id=25aef8cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aef8cb",
  null
  
)

export default component.exports